<template>
  <div>
    <template v-if="isMobile">
      <template v-if="!clientData">
        <dialogs-list v-if="agentData" :dialogs="agentData.clients" @select-dialog="selectUser($event)" />
      </template>
      <template v-else>
        <feedback-container v-if="clientData" />
      </template>
    </template>
    <template v-else>
      <feedback-container v-if="clientData" />
      <choose-client v-else />
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import ChooseClient from '../../components/client-detail/ChooseClient.vue'
import FeedbackContainer from '../../components/agent/feedback/FeedbackContainer.vue'
import DialogsList from '../../components/communication/DialogsList.vue'

export default {
  components: { ChooseClient, FeedbackContainer, DialogsList },
  computed: {
    /**
       * Mapping selected client from the Vuex store to local version
       */
    ...mapState('agent', ['agentData']),
    ...mapState('client', ['clientData']),
    ...mapState('common', ['isMobile'])
  },
  mounted() {
    if (this.clientData) {
      this.setShowingMobileBackButton(true)
    }
  },
  destroyed() {
    if (this.isMobile) {
      this.setClientData(null)
      this.setShowingMobileBackButton(false)
    }
  },
  methods: {
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    ...mapMutations('mobile', {
      setShowingMobileBackButton: 'SET_SHOWING_MOBILE_BACK_BUTTON'
    }),
    ...mapActions('agent', ['setSearchedClient']),
    selectUser(user) {
      this.setSearchedClient(user)
      this.setShowingMobileBackButton(true)
    }
  }
}
</script>
